import { DrawingToolType, ShapeConfig } from '.';

/**
 * This function returns the coordinates of the label to generate,
 * according to the type of shape that is passed
 * @param shapeConfig 
 */
export const getLabelCoordinates = (shapeConfig: ShapeConfig, labelRadius) => {

    switch (shapeConfig.type) {
        case DrawingToolType.CIRCLE:
            // Setting the label on the 'north-west' of the circle
            let labelCenterX = shapeConfig.x;
            let labelCenterY = shapeConfig.y;
            if (shapeConfig.radius) {
                // Default label position, top left
                labelCenterX = shapeConfig.x - shapeConfig.radius * Math.cos(Math.PI / 4);
                labelCenterY = shapeConfig.y - shapeConfig.radius * Math.sin(Math.PI / 4);

                // Relocating label if out of image bounds
                if (labelCenterX - labelRadius < 0) {
                    labelCenterX = shapeConfig.x + shapeConfig.radius * Math.cos(Math.PI / 4);
                }
                if (labelCenterY - labelRadius < 0) {
                    labelCenterY = shapeConfig.y + shapeConfig.radius * Math.sin(Math.PI / 4);
                }
            }
            return { x: labelCenterX, y: labelCenterY }
        case DrawingToolType.RECTANGLE:
            // setting label always in the upper left corner
            return { x: shapeConfig.x, y: shapeConfig.y }
        case DrawingToolType.FREE_DRAWING:
            // Setting the lable on the first point of the line
            if (shapeConfig.points) {
                return {
                    x: shapeConfig.points[0],
                    y: shapeConfig.points[1],
                }
            }
            return { x: 0, y: 0 }

        default: return { x: shapeConfig.x, y: shapeConfig.y }
    }
}